import { useContext } from 'react';

import { Button, Grid, IconButton, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

import { Button as StyledButton } from '../../common';
import StyledModal from '../StyledModal';
import colors from '../../../assets/colors';
import { storage } from '../../../utils/api';
import FarmContext from '../../../store/farm-context';

export default function DeleteWarehouseItemModal(props) {
  const farmCTX = useContext(FarmContext);

  const handleClose = () => props.setOpen(false);
  const handleDeleteWarehouseItem = () => {
    deleteWarehouseItem();
    handleClose();
  };

  const deleteWarehouseItem = () => {
    storage
      .delete(props.id, farmCTX.farmID)
      .then(() => props.updateWarehouse())
      .catch(() => {});
  };
  return (
    <StyledModal open={props.open}>
      <IconButton
        onClick={handleClose}
        sx={{
          color: colors.redButton,
          position: 'absolute',
          top: 5,
          right: 5,
        }}
      >
        <CancelIcon />
      </IconButton>
      <Grid container justifyContent="center">
        <Typography
          sx={{ fontSize: 36, fontWeight: 500, mb: 1, mt: 1, px: 4, py: 2 }}
        >
          Czy na pewno chcesz usunąć zasób?
        </Typography>
      </Grid>
      <Grid container justifyContent="center">
        <StyledButton
          red
          type="submit"
          variant="outlined"
          onClick={handleClose}
          sx={{ mr: 5 }}
        >
          ANULUJ
        </StyledButton>
        <Button
          type="submit"
          variant="outlined"
          onClick={handleDeleteWarehouseItem}
        >
          TAK, USUŃ
        </Button>
      </Grid>
    </StyledModal>
  );
}
